import jquery from 'jquery'
import './bundle'
import Url from 'domurl'

// polyfill to support forEach (needed for Microsoft Teams)
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }
}

window.jquery = window.$ = jquery
;(function(window) {
  // define global functions
  window.reloadWithLanguage = event => {
    console.log({ event })
    var url = new Url(window.location.href)
    url.query.lang = event.target.value
    window.location.href = url
    event.preventDefault()
    return false
  }

  document.addEventListener('DOMContentLoaded', function() {
    var elems = document.querySelectorAll('.modal')
    var instances = M.Modal.init(elems, {})
  })

  document.addEventListener('DOMContentLoaded', function() {
    var elems = document.querySelectorAll('select')
    var selectOptions = { dropdownOptions: { alignment: 'right', constrainWidth: false, outDuration: 1 } }
    var instances = M.FormSelect.init(elems, selectOptions)
  })

  var languageSelect = document.querySelectorAll('.language-select')
  if (languageSelect && languageSelect.length) {
    languageSelect.forEach(function(element) {
      element.addEventListener('change', function(event) {
        reloadWithLanguage(event)
      })
    })
  }
})(window)
